import React, { useState } from "react";
import styled from "@emotion/styled";
import { ClearedStyleInput } from "@modules/Components";
import { FaChevronDown } from "react-icons/fa";

const MainContainer = styled.div`
  position: relative;
`;

const InputContainer = styled.div`
  height: 72px;
  border-radius: 5px;
  background-color: #ffffff;
  position: relative;
  box-shadow: ${props =>
    props.errorState
      ? "0 20px 70px 0 rgba(31, 32, 33, 0.05)"
      : "0 20px 70px 0 rgba(31, 32, 33, 0.12)"};
  border: ${props => props.setBorder};
  z-index: 2;
  grid-template-columns: auto 40px;
  align-items: center;
`;

const AbsoluteIconContainer = styled.div`
  position: absolute;
  right: 27px;
  top: 44%;
  pointer-events: none;
`;

const Select = styled(ClearedStyleInput)`
  width: 100%;
  border: 0;
  height: 100%;
  font-size: 16px;
  color: ${props => props.setColor};
  padding-left: 30px;
  display: flex;
  align-items: center;
  cursor: text;
  text-align: left;
  border-radius: 5px;
  background-color: #ffffff;

  @media (max-width: 500px) {
    padding-left: 10px;
  }
  @media (max-width: 375px) {
    padding-left: 20px;
    font-size: 14px;
  }
`;

const Option = styled.div`
  color: rgba(31, 32, 33, 0.8);
  cursor: pointer;
  margin-bottom: 10px;
`;

const Absolutecontainer = styled.div`
  top: 6px;
  position: absolute;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  left: 30px;
  text-transform: uppercase;

  @media (max-width: 530px) {
    font-size: 9px;
  }
  @media (max-width: 500px) {
    left: 10px;
  }
  @media (max-width: 465px) {
    font-size: 8px;
  }
  @media (max-width: 375px) {
    left: 20px;
  }
`;

const ErrorContainer = styled(Absolutecontainer)`
  color: #ee5050;
`;

const Title = styled(Absolutecontainer)`
  color: rgba(31, 32, 33, 0.5);
`;

const DropDownContainer = styled.div`
  position: absolute;
  top: 66px;
  background-color: #ffffff;
  width: 100%;
  border-radius: 0px 0px 10px 10px;
  padding-left: 30px;
  z-index: 1;
  padding-top: 18px;
  padding-bottom: 10px;
  box-shadow: 0 5px 20px 0 rgba(38, 38, 38, 0.05);

  @media (max-width: 375px) {
    padding-left: 20px;
  }
`;

const DropDownInnerContainer = styled.div`
  max-height: 100px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const RenderDropdownNew = ({
  input,
  className,
  meta: { error, touched },
  defaultValue,
  list,
  addArrow
}) => {
  const [openDropdown, changeOpenDropdown] = useState(false);
  const [mouseOver, changeMouseOver] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = e => {
    input.onFocus(e);
    setIsFocused(true);
    changeOpenDropdown(true);
  };

  const handleBlur = e => {
    setIsFocused(false);
    if (!mouseOver) {
      input.onBlur(e);
      changeOpenDropdown(false);
    }
  };

  return (
    <MainContainer>
      <InputContainer
        errorState={touched && error}
        addArrow={addArrow}
        setBorder={
          touched && error
            ? "solid 1px rgba(238, 80, 80, 0.48)"
            : isFocused
            ? "solid 2px #1f2021"
            : ""
        }
      >
        <Select
          name={input.name}
          onChange={input.onChange}
          className={className}
          setColor={input.value ? "#1f2021" : "rgba(31, 32, 33, 0.65)"}
          onClick={handleFocus}
          value={input.value ? input.value : defaultValue}
          type="button"
        />
        {addArrow && (
          <AbsoluteIconContainer>
            <span>
              <FaChevronDown
                style={{
                  color: "rgba(119, 121, 132, 0.65)",
                  fontSize: "14px",
                  transition: "500ms transform"
                }}
              />
            </span>
          </AbsoluteIconContainer>
        )}
        <ErrorContainer>
          {touched && error && <div>{error}</div>}
        </ErrorContainer>
        <Title>{!error && input.value && <div>{defaultValue}</div>}</Title>
      </InputContainer>
      {openDropdown && (
        <DropDownContainer
          onMouseOver={() => changeMouseOver(true)}
          onMouseOut={() => changeMouseOver(false)}
        >
          <DropDownInnerContainer>
            {list.map((item, key) => (
              <Option
                onClick={e => {
                  input.onChange(item);
                  changeOpenDropdown(false);
                  changeMouseOver(false);
                  input.onBlur();
                  handleBlur(e);
                }}
                key={key}
              >
                {item.display ? item.display : item}
              </Option>
            ))}
          </DropDownInnerContainer>
        </DropDownContainer>
      )}
    </MainContainer>
  );
};

export default RenderDropdownNew;
